import { Partial } from '@40seas/entities/common';
import { UserNotificationCustomizations } from './user-notification-customizations.entity';

export class UpdateUserNotificationCustomizations extends Partial(UserNotificationCustomizations) {}
